import React from 'react'
import {Input} from '@thryvlabs/maverick'

function SliderRange({
  maxValue,
  range,
  product,
  handleOnChange,
  isDisabled,
  symbolTemplate = '',
  includeProduct,
  resetToLastValidValue = false,
  setResetToLastValidValue,
  lastValidValue,
  // Geo Add-On only (FULSAS-13425): floors the slider at an already-owned
  // quantity so it can't be dragged below what's purchased. minValue=0
  // (the default) reproduces the exact original min={0}/step-start behavior
  // for every other slider-based product.
  minValue = 0,
}) {
  const maxItems = maxValue / range
  const minItems = minValue / range
  const step = 100 / maxItems
  const [value, setValue] = React.useState(minItems * step || step)
  const [displayValue, setDisplayValue] = React.useState(minValue || range)

  React.useEffect(() => {
    if (includeProduct) {
      setValue(minItems * step || step)
      setDisplayValue(minValue || range)
    }
  }, [step, range, includeProduct, minItems, minValue])

  const handleChange = e => {
    // step is 100/maxItems, which repeats when maxItems doesn't divide 100
    const rawQuantity = Math.round(e.target.value / step)
    // Geo Add-On only: snap back up to the owned floor instead of letting
    // the drag go below it. minItems is 0 for every other slider product,
    // so this branch is never reached and behavior is unchanged for them.
    if (minItems > 0 && rawQuantity < minItems) {
      setValue(minItems * step)
      setDisplayValue(minItems * range)
      if (product.name === 'Additional Video Views') {
        handleOnChange(minItems * 100, product)
      } else {
        handleOnChange(minItems, product)
      }
      return
    }

    setValue(e.target.value)
    setDisplayValue(rawQuantity * range)

    if (product.name === 'Additional Video Views') {
      handleOnChange(rawQuantity * 100, product)
    } else {
      handleOnChange(rawQuantity, product)
    }
  }

  React.useEffect(() => {
    if (resetToLastValidValue) {
      setTimeout(() => {
        setValue(lastValidValue * step)
        setDisplayValue(lastValidValue)
        setResetToLastValidValue(false)
      }, 1000)
    }
    // eslint-disable-next-line
  }, [resetToLastValidValue])

  return (
    <Input
      key={product.id}
      variant="range-slider"
      min={0}
      max={maxItems}
      step={step}
      value={value}
      onChange={handleChange}
      name="range-input"
      rangeWholeNumber
      disabled={isDisabled}
      noRangeTextbox
      rangeSliderThumbValue={
        symbolTemplate
          ? `${symbolTemplate.replace('{0}', displayValue)}`
          : '' + displayValue
      }
    />
  )
}

export {SliderRange}
